import { ProjectAPI } from "../api";
export class Project {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getProject(payload) {
    const { data } = await ProjectAPI.getProject(payload);
    data.result = new Project(data.result);
    return data.result;
  }
}
